import { RoutePath } from '@core/types/route';

type Values = {
  href: RoutePath;
  text: string;
};

export const FALKO_ZANDER_ARTS: Values[] = [
  { href: RoutePath.SolovevStyle, text: 'Solovev Style' },
  { href: RoutePath.SystemaRyabko, text: 'Systema Ryabko' },
  { href: RoutePath.JuJutsu, text: 'Ju-Jutsu' },
];
